import * as queryString from './base.js';

export default queryString;
